<mat-button-toggle-group [arcErrorTooltip]="control()" [formControl]="control()" [ngClass]="toggleGroupClasses()">
    @for (item of items(); track item.value) {
        <mat-button-toggle [value]="item.value" [ngClass]="toggleButtonClasses()">
            <span>{{ item.label }}</span>
        </mat-button-toggle>
    }
</mat-button-toggle-group>
